import React, { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import Autocomplete from '@mui/material/Autocomplete';
import Header from '../header/Header';
import Swal from 'sweetalert2'
import { API_URL } from '../../Constants';


let apiUrl = API_URL;

const ButtonPrincipal = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px',
    gap: '10px',
    backgroundColor: '#161e55',
    '&:hover': {
        backgroundColor: '#A8C8AF',
    },
});


function CreateCommerce() {

    const handleCreateCommerceRequest = () => {
        let companyName = document.getElementById("razonSocial").value;
        const documentType = documentTypes.find(res => res.label === document.getElementById("commerceDocumentType").value).value;
        let documentNumber = document.getElementById("commerceDocumentNumber").value;
        let cellphone = document.getElementById("commerceCellphone").value;
        let address = document.getElementById("commerceAddress").value;
        let city = document.getElementById("commerceCity").value;
        let locationsNumber = document.getElementById("locationsNumber").value;
        let email = document.getElementById("email").value;
        let website = document.getElementById("commerceWebsite").value;
        const industry = industries.find(res => res.label === document.getElementById("industry").value).value;
        console.log(companyName);
        console.log(documentNumber);
        console.log(cellphone);
        console.log(address);
        if (companyName === "" || documentNumber === "" || cellphone === "" || address === "") {
            alert("Revisa los campos obligatorios")
        } else {
            let commerce = {
                companyName: companyName,
                cellphone: cellphone,
                documentType: documentType,
                documentNumber: documentNumber,
                address: address,
                city: city,
                locationsNumber: locationsNumber,
                email: email,
                website: website,
                industry: industry
            }
            createCommerce(commerce)
        }
    }

    const documentTypes = [
        { label: 'NIT', value: 'NIT' },
        { label: 'Cedula de Ciudadanía', value: 'CC' },
        { label: 'Cedula de extranjería', value: 'CE' }
    ];

    const industries = [
        { label: 'Ferreterias', value: 'Ferreterias' }
    ];

    const createCommerce = (commerce) => {
        fetch(apiUrl + '/v1/commerces', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json ',
                'Accept': 'application/json',
            },
            body: JSON.stringify(commerce),
        }).then(function (response) {
            if (response.ok) {
                response.json().then(function (res) {
                    console.log(res.uuid)
                    showSuccessCreated();
                });
            }
        }).catch(function (error) {
            console.log('Hubo un problema con la petición Fetch:' + error.message);
        });
    }

    const sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

    function showSuccessCreated() {

        Swal.fire({
            icon: 'success',
            title: 'Comercio creado!',
            showConfirmButton: false,
            timer: 1500
        });
        sleep(1500).then(() => {
            window.location = '/general-admin';
        })
    }

    const handleBackToHome = () => {
        window.location = '/general-admin';
    }

    return (
        <React.Fragment>
            <CssBaseline />
            <Header />
            <Container maxWidth="md">
                <br />
                <br />
                <br />
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={3}>
                        <Grid item xs />
                        <Grid item xs={5}>
                            <Stack spacing={4.5}>
                                <TextField required id="razonSocial" label="Razón social" variant="outlined" />
                                <Autocomplete
                                    disablePortal
                                    id="commerceDocumentType"
                                    options={documentTypes}
                                    defaultValue={documentTypes[0]}
                                    renderInput={(params) => <TextField {...params} required label="Tipo de Documento" />}
                                />
                                <TextField required id="commerceDocumentNumber" label="Numero de identificación" variant="outlined" />
                                <TextField id="email" label="Correo electrónico / Email" variant="outlined" />
                                <TextField required id="commerceWebsite" label="Website" variant="outlined" />


                            </Stack>
                            <br />
                            <br />
                            <Stack spacing={2} direction="row">
                                <ButtonPrincipal variant="contained" onClick={handleBackToHome}>Volver</ButtonPrincipal>
                                <ButtonPrincipal variant="contained" onClick={handleCreateCommerceRequest}>Crear comercio</ButtonPrincipal>
                            </Stack>
                        </Grid>
                        <Grid item xs={5}>
                            <Stack spacing={4.5}>

                                <TextField id="commerceCellphone" label="Celular" variant="outlined" />
                                <TextField id="commerceAddress" label="Dirección" variant="outlined" />
                                <TextField id="locationsNumber" label="Numero de sedes" variant="outlined" />
                                <TextField id="commerceCity" label="Ciudad / Municipio" variant="outlined" />
                                <Autocomplete
                                    disablePortal
                                    id="industry"
                                    options={industries}
                                    defaultValue={industries[0]}
                                    renderInput={(params) => <TextField {...params} required label="Sector del comercio" />}
                                />
                            </Stack>
                            <br />
                            <br />
                        </Grid>
                        <Grid item xs />
                    </Grid>
                </Box>
            </Container>


        </React.Fragment>

    );
}

export default CreateCommerce;